import React, { useState, useEffect, useMemo } from 'react';
import { FaStar, FaSearch } from 'react-icons/fa';
import { useTable, useSortBy } from 'react-table';
import ReactPaginate from 'react-paginate';
import { Loader } from '../../../components/base/Loader';
import { allShovelersInfo, updateShovelerStatus } from '../../../apiManager/admin/ShovelersManagement.js';
import "./UserManagement.css"
import Papa from 'papaparse'
import api from '../../../apiManager/api.js';
import { Button } from '../../../components/ui/button';
import { Input } from "../../../components/ui/input";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from "../../../components/ui/select";
import { FiDownload } from "react-icons/fi";

function CustomerTable() {
    const [sortBy, setSortBy] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedStatus, setSelectedStatus] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [shovelers, setShovelers] = useState([]);
    const [error, setError] = useState('');
    const [totalCount, setTotalCount] = useState(10);
    const rowsPerPage = 8;

    useEffect(() => {
        (async function () {
            const res = await api.get(`/auth/getAllShovelersCount`);
            setTotalCount(res.data.count);
        })();
    }, [])

    useEffect(() => {
        const getShovelersData = async () => {
            try {
                setLoading(true);
                const res = await allShovelersInfo(currentPage + 1);
                if (!res) setShovelers([]);
                else setShovelers(res);
            } catch (error) {
                setError(error.message || "An error occurred while fetching data");
            } finally {
                setLoading(false);
            }
        }
        getShovelersData();
    }, [currentPage]);


    const handlePageClick = ({ selected }) => {
        setCurrentPage(selected);
    };

    const renderStars = (rating) => {
        const totalStars = 5;
        return (
            <div className="flex">
                {[...Array(totalStars)].map((_, i) => (
                    <FaStar
                        key={i}
                        className={i < rating ? 'text-yellow-500' : 'text-gray-300'}
                    />
                ))}
            </div>
        );
    };

    const columns = useMemo(
        () => [
            {
                Header: 'Role',
                accessor: 'userRole',
                Cell: ({ row }) => (
                    <div>
                        {row.original.shovelerDetails.userRole}
                    </div>
                ),
            },
            {
                Header: 'User Name',
                accessor: 'userName',
                Cell: ({ row }) => (
                    <div>
                        {row.original.shovelerDetails.userName}
                        {renderStars(row.original.statistics.averageRating)}
                    </div>
                ),
            },
            {
                Header: 'Full Name',
                accessor: 'name',
                Cell: ({ row }) => (
                    <div>
                        {row.original.shovelerDetails.firstName} {row.original.shovelerDetails.lastName}
                    </div>
                ),
            },
            {
                Header: 'Address',
                accessor: 'address',
                Cell: ({ row }) => (
                    <div>
                        {row.original.shovelerDetails.address}
                    </div>
                ),
            },
            {
                Header: 'Phone Number',
                accessor: 'phone',
                Cell: ({ row }) => (
                    <div>
                        {row.original.shovelerDetails.phone}
                    </div>
                ),
            },
            {
                Header: 'Email',
                accessor: 'email',
                Cell: ({ row }) => (
                    <div>
                        {row.original.shovelerDetails.email}
                    </div>
                ),
            },
            {
                Header: 'Sign Up Date',
                accessor: 'dateJoined',
                Cell: ({ row }) => (
                    <div>
                        {new Date(row.original.shovelerDetails.dateJoined).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        })}

                    </div>
                ),
            },
            {
                Header: 'Status',
                accessor: 'status',
                Cell: ({ row }) => {
                    console.log(row.original)
                    // Determine the current status
                    const currentStatus = selectedStatus[row.index] || row.original.shovelerDetails.status;

                    // Define the className based on the status
                    const className = `px-2 py-1 rounded ${currentStatus === 'Suspend' ? 'bg-yellow-500 text-white'
                        : currentStatus === 'Activate' ? 'bg-green-500 text-white'
                            : currentStatus === 'Deactivate' ? 'bg-red-500 text-white'
                                : 'bg-zinc-500 text-white'// Default for any other status
                        }`;

                    return (
                        <select
                            className={className} // Apply the className based on status
                            value={currentStatus} // Use the current status as the value
                            onChange={(e) => handleStatusChange(row.index, e.target.value)} // Update the status on change
                        >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                            <option value="suspend">Suspend</option>
                        </select>
                    );
                },
            },
            {
                Header: 'Average Price',
                accessor: 'averagePrice',
                Cell: ({ row }) => (
                    <div>
                        ${row.original.statistics.averagePrice ? parseInt(row.original.statistics.averagePrice)/100 : 0}
                    </div>
                ),
            },
            {
                Header: 'Services Provided/Requested',
                accessor: 'completedJobs',
                Cell: ({ row }) => (
                    <div>
                        {row.original.statistics.completedJobs}
                    </div>
                ),
            },
            {
                Header: 'Cancelled Services',
                accessor: 'canceledJobs',
                Cell: ({ row }) => (
                    <div>
                        {row.original.statistics.canceledJobs}
                    </div>
                ),
            },
            {
                Header: 'Payments Recieved/Made',
                accessor: 'totalPayments',
                Cell: ({ row }) => (
                    <div>
                        ${row.original.statistics.totalPayments/100}
                    </div>
                ),
            },
        ],
        [selectedStatus]
    );

    const data = useMemo(() => {
        console.log("Shovelers", shovelers);
        return shovelers
            .filter((shoveler) =>
                shoveler.shovelerDetails.userName.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .filter((shoveler) => {
                // Check if "All" is selected, if yes, don't apply the status filter
                if (sortBy.toLowerCase() === 'all') {
                    return true; // Include all shovelers
                }
                return shoveler.shovelerDetails.status.toLowerCase() === sortBy.toLowerCase();
            });
    }, [shovelers, searchTerm, sortBy]);
    

    
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data }, useSortBy);

    const handleStatusChange = async (index, value) => {
        // Update the selected status in the state
        setSelectedStatus((prevStatus) => ({
            ...prevStatus,
            [index]: value,
        }));

        // Ensure that the shovelerDetails exists before making the API call
        const shoveler = shovelers[index];
        if (shoveler && shoveler.shovelerDetails) {
            await updateShovelerStatus(shoveler.shovelerDetails._id, value);
        } else {
            console.error(`Shoveler details are missing or undefined for index ${index}`);
        }
    };

    const exportToCsv = async () => {
        const res = await allShovelersInfo();
        const transformedData = res.map(({ shovelerDetails, statistics }) => ({
            Role: shovelerDetails.userRole,
            "User Name": shovelerDetails.userName,
            Address: shovelerDetails.address,
            "Phone Number": shovelerDetails.phone.toString(),
            Email: shovelerDetails.email,
            "Sign Up Date": new Date(shovelerDetails.dateJoined).toLocaleDateString(),
            Status: shovelerDetails.status,
            "Average Price": statistics.averagePrice ? statistics.averagePrice / 100 : 0,
            "Services Provided/Requested": statistics.completedJobs,
            "Cancelled Services": statistics.canceledJobs,
            "Payments Recieved/Made": statistics.totalPayments / 100
          }));
          const csv = Papa.unparse(transformedData);

            const blob = new Blob([csv], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = 'shovelers_data.csv';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
    }


    
    if (loading) {
        return <Loader />;
    }
    
    if (error) {
        return <p className="text-red-500">{error}</p>;
    }
    
    if (!shovelers.length) {
        return <p>No shovelers available</p>;
    }
    return (

        // table header
        <div className="">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mt-6 mb-12 gap-6 md:gap-x-20">
  {/* Left Section */}
  <div>
    <h2 className="text-2xl font-semibold tracking-tight">All Users</h2>
    <p className="text-muted-foreground text-sm">Active Members</p>
  </div>

  {/* Center: Search + Filter */}
  <div className="flex flex-col sm:flex-row w-full md:w-auto gap-3 md:gap-4">
    {/* Search Input */}
    <div className="relative w-full sm:w-64">
      <Input
        type="text"
        placeholder="Search users..."
        id="gsearch"
        name="gsearch"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="pl-10"
      />
      <FaSearch
        size={16}
        className="absolute top-1/2 left-3 -translate-y-1/2 text-muted-foreground"
      />
    </div>

    {/* Filter Dropdown */}
    <Select value={sortBy} onValueChange={setSortBy}>
      <SelectTrigger className="w-full sm:w-40">
        <SelectValue placeholder="Filter by status" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All</SelectItem>
        <SelectItem value="active">Active</SelectItem>
        <SelectItem value="inactive">Inactive</SelectItem>
        <SelectItem value="suspend">Suspend</SelectItem>
      </SelectContent>
    </Select>
  </div>

  {/* Right: Export Button */}
  <div className="w-full md:w-auto">
    <Button
      variant="secondary"
      className="w-full md:w-auto flex items-center gap-2"
      onClick={exportToCsv}
    >
      <FiDownload size={18} />
      Export CSV
    </Button>
  </div>
</div>

            {/* table container */}
            <div className='overflow-x-auto'>
                <table {...getTableProps()} className="min-w-full bg-white">
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {column.render('Header')}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                        {rows.map((row) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()} className="hover:bg-gray-100">
                                    {row.cells.map((cell) => (
                                        <td
                                            {...cell.getCellProps()}
                                            className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                                        >
                                            {cell.render('Cell')}
                                        </td>
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {/* paginator */}
            <ReactPaginate
                className='pagination-container flex justify-end me-32 mt-10 gap-x-5'
                previousLabel={
                    <span className="flex items-center justify-center px-2 rounded-md border border-gray-300 hover:bg-gray-300 transition duration-200 ease-in-out">
                        &lt;
                    </span>
                }
                nextLabel={
                    <span className="flex items-center justify-center px-2 rounded-md border border-gray-300 hover:bg-gray-300 transition duration-200 ease-in-out">
                        &gt;
                    </span>
                }
                breakLabel={<span className="mx-2 text-gray-600">...</span>}
                breakClassName='break-me'
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                pageCount={Math.ceil(totalCount/rowsPerPage)}
                forcePage={currentPage}
                onPageChange={handlePageClick}
                containerClassName={`flex items-center`}
                pageLinkClassName={`bg-gray-200 px-2 py-1 rounded-md border border-gray-300 hover:bg-gray-300 transition duration-200 ease-in-out`}
                activeLinkClassName={`bg-zinc-900 text-white rounded-md`}
                disabledClassName={`opacity-50 cursor-not-allowed`}
            />

        </div>
    );
}

export default CustomerTable;